/* @flow */

import Render from './Render';
import Edit from './Edit';
import View from './View';

export const getEditComponent = () => Edit;
export const getViewComponent = () => View;
export const getRenderComponent = () => Render;



// WEBPACK FOOTER //
// ./src/modules/edito/plugins/text/index.js